import React, { useEffect, useState } from 'react';
import '../../../styles/mainContents.css'
import { useSelector, useDispatch, connect } from 'react-redux';
import { Link, Switch, useHistory } from 'react-router-dom';
import MUIDataTable from 'mui-datatables';
import moment from 'moment';
import { fetchSubmitEditUser, adminFetchUsers, adminFetchCustomerPermissions } from '../../../redux/actions/AdminActions';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import { Tooltip, IconButton } from '@mui/material';
import Select from 'react-select';
import '../../../styles/mainContents.css';

function UsersRole(props) {

  const dispatch = useDispatch();
  const history = useHistory();

  const { fetch_submitEditUser, customerPermissionReducerState, fetch_adminFetchCustomerPermissions, adminReducerState, fetch_adminFetchUsers, authreducerState } = props;
  // console.log("UsersRole authreducerState: " + JSON.stringify(authreducerState));  
  // console.log("UsersRole adminReducerState: " + JSON.stringify(adminReducerState));  

  let [isDialogOpen, setIsDialogOpen] = useState(false)

  useEffect( () => { 
    fetch_adminFetchUsers(authreducerState.user); 
    fetch_adminFetchCustomerPermissions();
  }, []);

  const columnsOptions_usersRole = (colName='', inputType='number') => {
    var options = {};
    let maxValue = 1000;

    colName === '' ?
      options = {
        filter: true,
        sort: true, 
        setCellHeaderProps: () => ({
          style: {
            whiteSpace: "nowrap",
            position: "sticky",
            top: '0px',
            zIndex: 101,            
          }
        })               
      }
    :
      options = {
        filter: true,
        sort: true,
        setCellHeaderProps: () => ({
          style: {
            whiteSpace: "nowrap",
            position: "sticky",
            top: 0,
            zIndex: 101,            
          }
        }),            
        customBodyRenderLite: (dataIndex, rowIndex) => {
          return (
            <span></span>
          )
        }
      }
    return options;
  }

  const columnsUsersRole = [
    {
      name: "USERNAME",
      label: "Username",
      options: columnsOptions_usersRole(),
    },
    {
      name: "EMAIL",
      label: "Email",
      options: columnsOptions_usersRole(),
    },
    {
      name: "NAME",
      label: "Name",
      options: columnsOptions_usersRole(),
    },
    {
      name: "ROLE_NAME",
      label: "Role Name",
      options: columnsOptions_usersRole(),
    },   
        
  ]

  const optionsUsersRole = {
    filterType: "checkbox",
    selectableRows: "none",
    responsive: "standard",
    onRowClick: (rowData, rowMeta) => {
      console.log("UsersRole optionsUsersRole onRowClick rowData:" + JSON.stringify(rowData) + " rowMeta:" + JSON.stringify(rowMeta));
    },
    onChangePage (currentPage) {
      console.log({currentPage});
     
    },
    rowsPerPage: 100,
  };  


  let EditUserDialog = () => {    
    let editUserList = adminReducerState.map( (item,i) => { return { ...item, 'value': item['USERNAME'], 'label': item['USERNAME'] }; });
    const [editUserSelectedState, setEditUserSelectedState] = useState({EMAIL:'', NAME: '', ROLE_NAME: ''});
    
    let editPermissionList = customerPermissionReducerState.map( (item,i) => { return { 'value': item['PERMISSION_TYPE'], 'label': item['PERMISSION_TYPE'] }; });
    const [editPermissionSelectedState, setEditPermissionSelectedState] = useState(null);
    
    return (
      isDialogOpen === true ? 
        <>
        
        {/* <Dialog maxWidth={'3'} onClose={() => { setIsDialogOpen(false); setClickedInvnoState(null); fetch_customerDetailReset(); dispatchSetRotateRequestState([]); dispatchSetNoRotatesNeededCbState(false); }} open={isDialogOpen}> */}
        <Dialog maxWidth={'3'} onClose={() => {  }} open={isDialogOpen}>
            
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title" >
              <div style={ {fontWeight:'bold', textAlign:'left', minWidth:'100%', width: '400px', margin:'0', padding:'0'} }>Edit User </div>

            </DialogTitle>      
            <IconButton
              aria-label="close"
              //onClick={() => { setIsDialogOpen(false); setClickedInvnoState(null); fetch_customerDetailReset(); dispatchSetRotateRequestState([]); dispatchSetNoRotatesNeededCbState(false); }}
              onClick={() => { setIsDialogOpen(false);  }}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
            
            <DialogContent dividers>
             
              { 
                (authreducerState.user.role_name === undefined) ? "" :                    
                (authreducerState.user.role_name !== 'ADMIN' && authreducerState.user.role_name !== 'EDITOR') ? "No access to submit user change" 
                :  
                  <React.Fragment>
                                       
                    <table id='editUserTbl'>
                      
                      <thead>
                        <tr>
                          <td colSpan={3}>
                            Select Username:                                                         
                            <Select menuPosition="fixed" menuPlacement="top" 
                              options={ editUserList }                              
                              onChange={ e => {
                                setEditUserSelectedState(e);
                                setEditPermissionSelectedState({value: e.ROLE_NAME, label: e.ROLE_NAME});
                              }
                            }/> 
                          </td>
                        </tr>
                      </thead>
                      <tbody>

                        <tr>
                          <td colSpan={3}>
                            <div className='edit-line-container'>
                              <span className="line"></span>
                              <span className="center-word">Edit</span>
                              <span className="line"></span>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>Email:</td>
                          <td>Name:</td>
                          <td>Role Name:</td>
                        </tr>
                        <tr>
                          <td>
                            <input id='adminEditEmailId' type="text" placeholder='EMAIL' 
                              key={'adminEditEmailKey'}
                              name={'adminEditEmailName'}
                              value={editUserSelectedState.EMAIL}
                              onChange={ (e) => {
                                setEditUserSelectedState({...editUserSelectedState, 'EMAIL': e.target.value.trim()});
                              }}
                            />
                          </td>
                          <td>
                            <input id='adminEditNameId' type="text" placeholder='NAME'
                              key={'adminEditNameKey'}
                              name={'adminEditNameName'}
                              value={editUserSelectedState.NAME}
                              onChange={ (e) => {
                                setEditUserSelectedState({...editUserSelectedState, 'NAME': e.target.value.trim()});
                              }}
                            />                            
                          </td>
                          <td>
                            <Select menuPosition="fixed" menuPlacement="top"
                              key={'editPermissionListKey'} 
                              options={ editPermissionList } 
                              value={editPermissionSelectedState }                             
                              onChange={ e => {
                                setEditPermissionSelectedState(e);
                                setEditUserSelectedState({...editUserSelectedState, 'ROLE_NAME': e.value });

                                console.log('editUserSelectedState',editUserSelectedState)
                              }
                            }/>
                                                      
                          </td>                                                                        
                        </tr>                        
                      </tbody>

                    </table>
                  </React.Fragment>                        

                    
              }           
            </DialogContent>
            


            <DialogActions>
              <Button onClick={(e) => 
                {   
                  fetch_submitEditUser(editUserSelectedState, authreducerState.user);
                }}>
                Submit User Change
              </Button>
            </DialogActions>       
        </Dialog>
        </>
      : ''
    )

  }


  return (

    <div>
        <div>   

          <div>
            <button onClick={ () => {
               setIsDialogOpen(true)
            }}>Edit User</button>
          </div>

          <div id='usersTblId'>        
            { adminReducerState !== undefined ?
              adminReducerState.length > 0 ?                
                <div>
                  <MUIDataTable
                    title={
                      "Users Role Management"
                    }                
                    data={adminReducerState}
                    columns={columnsUsersRole}
                    options={optionsUsersRole}
                  />


                </div>
              
              : ''
              : ''
            }

          </div>

          <EditUserDialog/>

        </div>
    </div>

  );
}


const mapStateToProps = (state) => {
  //console.log("UsersRole() mapStateToProps state: " + JSON.stringify(state));

 return {  
  authreducerState: state.authreducer,
  adminReducerState: state.adminReducer['adminUsers'],
  customerPermissionReducerState: state.adminReducer['customerPermissions'],

 }

};

const mapDispatchToProps = (dispatch) => {
  return {
    fetch_adminFetchUsers: (user) => {
      dispatch(adminFetchUsers(user));
    }, 
    fetch_adminFetchCustomerPermissions: (user) => {
      dispatch(adminFetchCustomerPermissions(user));
    }, 
    fetch_submitEditUser: (editedState) => {
      dispatch(fetchSubmitEditUser(editedState));
    },     
    
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UsersRole);